import React from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../../store/actions/deviceProfile";
import { updateUI as updateLocationUI } from "../../../../store/actions/location";
import ExistingLocationFormGroup from "./existingLocationFormGroup";
import NewLocationFormGroup from "./newLocationFormGroup";

function LocationFormGroup(props) {
  const { title, stateSelectorIndex } = props;
  const dispatch = useDispatch();
  const { formFields } = useSelector((state) => ({
    formFields: state.deviceProfile.ui.form.fields,
  }));

  const locationForm = useSelector((state) => state?.location?.ui?.form);

  const handleResetLocationGroup = (index) => {
    const locations = formFields?.step3?.locations?.map((loc, i) => {
      if (i === index) {
        return {
          currentLocation: "",
          existing: {
            shipping: {
              isValid: true,
              class: "",
              value: loc?.existing?.shipping?.value,
              error: "",
            },
            pointName: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            address: {
              isValid: false,
              class: "",
              value: "",
              error: "",
              mapBoxTheme: {
                cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                variables: {
                  unit: "14px",
                  padding: "0.5em",
                  border: "1px solid rgba(111, 113, 113, 1)",
                  borderRadius: "4px",
                  boxShadow: "none",
                },
              },
            },
            latitude: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            trigger: {
              isValid: false,
              class: "",
              value: "entry and exit",
              error: "",
            },
            longitude: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            radius: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            alerttype: {
              isValid: false,
              class: "",
              value: "notification",
              error: "",
            },
            alertgroup: {
              isValid: false,
              class: "",
              value: undefined,
              error: "",
            },
          },
          new: {
            shipping: {
              isValid: true,
              class: "",
              value: loc?.existing?.shipping?.value,
              error: "",
            },
            pointName: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            address: {
              isValid: false,
              class: "",
              value: "",
              error: "",
              mapBoxTheme: {
                cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                variables: {
                  unit: "14px",
                  padding: "0.5em",
                  border: "1px solid rgba(111, 113, 113, 1)",
                  borderRadius: "4px",
                  boxShadow: "none",
                },
              },
            },
            latitude: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            trigger: {
              isValid: false,
              class: "",
              value: "entry and exit",
              error: "",
            },
            longitude: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            radius: {
              isValid: false,
              class: "",
              value: "",
              error: "",
            },
            alerttype: {
              isValid: false,
              class: "",
              value: "notification",
              error: "",
            },
            alertgroup: {
              isValid: false,
              class: "",
              value: undefined,
              error: "",
            },
          },
        };
      }
      return loc;
    });
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations,
            },
          },
        },
      })
    );
  };

  const handleRemoveLocationGroup = (index) => {
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              locations: formFields.step3.locations.filter(
                (_, i) => index !== i
              ),
            },
          },
        },
      })
    );
  };

  const handleSelectLocation = (stateSelectorIndex, value) => {
    if (value === "new") {
      dispatch(
        updateUI({
          key: "form",
          value: {
            isOpen: false,
            fields: {
              ...formFields,
              step3: {
                ...formFields.step3,
                currentLocationIndex: stateSelectorIndex,
                locations: formFields.step3.locations.map((location, index) => {
                  if (index === stateSelectorIndex) {
                    return {
                      ...formFields.step3.locations[index],
                      //currentLocation: value,
                    };
                  }

                  return location;
                }),
              },
            },
          },
        })
      );
      dispatch(
        updateLocationUI({
          key: "form",
          state: {
            ...locationForm,
            type: "create",
          },
        })
      );
      return;
    }

    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step3: {
              ...formFields.step3,
              currentLocationIndex: null,
              locations: formFields.step3.locations.map((location, index) => {
                if (index === stateSelectorIndex) {
                  return {
                    ...formFields.step3.locations[index],
                    currentLocation: value,
                    [value]: {
                      ...formFields.step3.locations[index][value],
                      address: {
                        isValid: false,
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                                  .Input {
                                      height: 44px;
                                      font-size: 1rem;
                                      font-weight: 400;
                                      color: #212529;
                                      font-family: system-ui;
                                      pointer-events: none;
                                      pointer-events: none;
                                  }
                                  .ClearBtn {
                                      display: none !important;
                                  }
                              `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                    },
                  };
                }

                return location;
              }),
            },
          },
        },
      })
    );
  };

  return (
    <div className="py-1">
      <div className="d-flex flex-row justify-content-between align-items-center">
        {title && (
          <div
            className="font-face-vzw"
            style={{
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            {title}
          </div>
        )}
        {!title && (
          <div
            className="font-face-vzw"
            style={{
              fontWeight: 700,
              fontSize: "16px",
              color: "#6F7171",
            }}
          >
            Shipping name
          </div>
        )}
        {stateSelectorIndex !== 0 && stateSelectorIndex !== 1 ? (
          <div>
          <button
            onClick={() => handleResetLocationGroup(stateSelectorIndex)}
            type="button"
            className="remove-btn-link"
            disabled={ 
                formFields?.step3?.locations[stateSelectorIndex]
                  ?.currentLocation === "" }
          >
            Reset
          </button>
          <button
            onClick={() => handleRemoveLocationGroup(stateSelectorIndex)}
            type="button"
            className="remove-btn-link"
          >
            Remove
          </button>
          </div>
        ) : (
          <button
            onClick={() => handleResetLocationGroup(stateSelectorIndex)}
            type="button"
            className="remove-btn-link"
            disabled={ 
                formFields?.step3?.locations[stateSelectorIndex]
                  ?.currentLocation === "" }
          >
            Reset
          </button>
        )}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-start">
        <span className="py-2">
          Would you like to add an existing location or a create a new one?
        </span>
        <Radio.Group
          block
          onChange={(e) =>
            handleSelectLocation(stateSelectorIndex, e?.target?.value)
          }
          options={[
            {
              label: (
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div
                    style={{
                      fontFamily:"VerizonNHGDSBold",
                      fontWeight: 700,
                      fontSize: "16px",
                      lineHeight: "20px",
                      color:"black"
                    }}
                  >
                    Existing locations
                  </div>
                  <div
                    style={{
                      fontFamily: "VerizonNHGDS",
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "20px",
                      color:"black"
                    }}
                  >
                    Select an existing location
                  </div>
                </div>
              ),
              value: "existing",
              disabled:
                formFields?.step3?.locations[stateSelectorIndex]
                  ?.currentLocation === "new",
            },
            {
              label: (
                <div className="d-flex flex-column justify-content-center align-items-start">
                  <div
                    style={{
                      fontFamily:"VerizonNHGDSBold",
                      fontWeight: 700,
                      fontSize: "16px",
                      lineHeight: "20px",
                      color:"black"
                    }}
                  >
                    New location
                  </div>
                  <div
                    style={{
                      fontFamily: "VerizonNHGDS",
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "20px",
                      color:"black"
                    }}
                  >
                    {" "}
                    Create a new location
                  </div>
                </div>
              ),
              disabled:
                formFields?.step3?.locations[stateSelectorIndex]
                  ?.currentLocation === "existing",
              value: "new",
            },
          ]}
          value={
            formFields?.step3?.locations[stateSelectorIndex]?.currentLocation
          }
          optionType="button"
          buttonStyle="solid"
          className="ats-radio-group"
        />
      </div>
      {formFields?.step3?.locations[stateSelectorIndex]?.currentLocation ===
        "existing" && (
        <ExistingLocationFormGroup stateSelectorIndex={stateSelectorIndex} />
      )}
      {formFields?.step3?.locations[stateSelectorIndex]?.currentLocation ===
        "new" && (
        <NewLocationFormGroup stateSelectorIndex={stateSelectorIndex} />
      )}
      <hr style={{ width: "100%" }}/>
    </div>
  );
}

LocationFormGroup.propTypes = {
  title: PropTypes.string,
  stateSelectorIndex: PropTypes.number.isRequired,
};

export default LocationFormGroup;
